// ---------------------------------------------------------------------------
// /privacy-policy — compatibility route.
//
// The canonical Self Doubling ecosystem now uses iubenda as the SINGLE
// authoritative Privacy Policy (and Cookie Policy, and Terms & Conditions).
// The former native privacy-policy page maintained inside this React
// application has been retired to prevent legal drift between two
// separately-maintained documents.
//
// This route is preserved as a compatibility URL so that existing links,
// bookmarks and email references never break. On mount it performs an
// EXTERNAL BROWSER REDIRECT (window.location.replace) to the official
// iubenda-hosted Privacy Policy. This is a real full-page navigation, NOT
// a client-side SPA route change (which would not be an appropriate
// substitute for a real HTTP redirect).
//
// NOTE: The Emergent preview/production runtime serves this SPA route
// through the React application shell, so a true HTTP 301 at the origin
// is not available from this layer. This browser-level redirect is the
// approved fallback per the compatibility-route decision.
// ---------------------------------------------------------------------------

import { useEffect } from "react";

const IUBENDA_PRIVACY_POLICY_URL =
  "https://www.iubenda.com/privacy-policy/84007906";

export default function PrivacyPolicy() {
  useEffect(() => {
    // Replace (not push) so this compat URL is not stored in browser history.
    window.location.replace(IUBENDA_PRIVACY_POLICY_URL);
  }, []);

  // Minimal accessible fallback for the fraction of a second before the
  // browser navigates, and for the (rare) no-JS case.
  return (
    <main
      className="min-h-screen flex items-center justify-center bg-primary text-cream p-8"
      data-testid="privacy-policy-compat"
    >
      <noscript>
        <meta httpEquiv="refresh" content={`0; url=${IUBENDA_PRIVACY_POLICY_URL}`} />
      </noscript>
      <p className="font-body text-sm text-secondary text-center max-w-md">
        Redirecting to the Self Doubling Privacy Policy…{" "}
        <a
          href={IUBENDA_PRIVACY_POLICY_URL}
          className="text-gold-light underline underline-offset-4"
          data-testid="privacy-policy-manual-link"
        >
          Continue manually
        </a>
        .
      </p>
    </main>
  );
}
